import React from 'react'
import "./HighLightComponent.css"

const HighlightComponent = () => {
  return (
    <section className="troo-da-why-choose-section" id="troo-da-why-choose-section">
    <div className="container">
      <div className="row">
        <div className="col-md-6 highlight_left">
          <div className="why-choose-img"></div>
        </div>
        <div className="col-md-6 ">
          <div className="why-choose-text">
            <div className="troo-tile">
              <span>People why choose us again and again</span>
              <h2>The Reason we are the best in 
                this business sinse 30+ years</h2>
            </div>
            <p>It is a long established fact that it is also reader we arewill be distracted by the readable content of
              a page when looking at
              its layout.
              The point of using Lorem Ipsum is that it has a more less normal distribution of letters</p>
            <ul>
              <li>
                <div className="chose-list-img"><svg width="34" height="34" viewBox="0 0 34 34" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M31.1667 29.75V26.9167C31.1667 24.2762 29.3607 22.0576 26.9167 21.4285M21.9583 4.66191C24.0351 5.50254 25.5 7.53852 25.5 9.91667C25.5 12.2948 24.0351 14.3308 21.9583 15.1714M24.0833 29.75C24.0833 27.1097 24.0833 25.7895 23.652 24.7481C23.0769 23.3596 21.9737 22.2565 20.5852 21.6813C19.5438 21.25 18.2237 21.25 15.5833 21.25H11.3333C8.69301 21.25 7.37284 21.25 6.33147 21.6813C4.94298 22.2565 3.83983 23.3596 3.26469 24.7481C2.83334 25.7895 2.83334 27.1097 2.83334 29.75M19.125 9.91667C19.125 13.0463 16.588 15.5833 13.4583 15.5833C10.3287 15.5833 7.79168 13.0463 7.79168 9.91667C7.79168 6.78705 10.3287 4.25 13.4583 4.25C16.588 4.25 19.125 6.78705 19.125 9.91667Z"
                      stroke="#E27394" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
                <div className="chose-list-text">
                  <h4>Qualified staff</h4>
                  <p>It is a long established fact that it is also reader we arewill be distracted
                    by the readable content.</p>
                </div>
              </li>
              <li>
                <div className="chose-list-img"><svg width="34" height="34" viewBox="0 0 34 34" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M9.91668 31.1668V15.5835M2.83334 18.4168V28.3335C2.83334 29.8983 4.10187 31.1668 5.66668 31.1668H24.6872C26.7849 31.1668 28.5688 29.6364 28.8878 27.5631L30.4134 17.6464C30.8095 15.0719 28.8176 12.7502 26.2128 12.7502H21.25C20.4676 12.7502 19.8333 12.1159 19.8333 11.3335V6.32677C19.8333 4.39749 18.2694 2.8335 16.3401 2.8335C15.8799 2.8335 15.4629 3.1045 15.276 3.525L10.2906 14.7422C10.0632 15.2538 9.55587 15.5835 8.99602 15.5835H5.66668C4.10187 15.5835 2.83334 16.852 2.83334 18.4168Z"
                      stroke="#E27394" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
                <div className="chose-list-text">
                  <h4>Veriety of services</h4>
                  <p>It is a long established fact that it is also reader we arewill be distracted
                    by the readable content.</p>
                </div>
              </li>
              <li>
                <div className="chose-list-img"><svg width="34" height="34" viewBox="0 0 34 34" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M14.1667 20.591C15.9142 19.581 18.0857 19.581 19.8332 20.591M2.83334 21.2502L3.82712 11.3124C3.8648 10.9356 3.88364 10.7472 3.91253 10.5856C4.25316 8.6801 5.83838 7.2455 7.76833 7.09616C7.93202 7.0835 8.12135 7.0835 8.50001 7.0835M31.1667 21.2502L30.1729 11.3124C30.1352 10.9356 30.1164 10.7472 30.0875 10.5856C29.7469 8.6801 28.1616 7.2455 26.2317 7.09616C26.068 7.0835 25.8787 7.0835 25.5 7.0835M12.507 17.2432C14.7199 19.4562 14.7199 23.0441 12.507 25.2571C10.294 27.4701 6.70605 27.4701 4.49307 25.2571C2.2801 23.0441 2.2801 19.4562 4.49307 17.2432C6.70603 15.0303 10.294 15.0303 12.507 17.2432ZM29.507 17.2432C31.7199 19.4562 31.7199 23.0441 29.507 25.2571C27.294 27.4701 23.706 27.4701 21.4931 25.2571C19.2801 23.0441 19.2801 19.4562 21.4931 17.2432C23.706 15.0303 27.294 15.0303 29.507 17.2432Z"
                      stroke="#E27394" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
                <div className="chose-list-text">
                  <h4>Unique form other spa treatments</h4>
                  <p>It is a long established fact that it is also reader we arewill be distracted
                    by the readable content.</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
  )
}

export default HighlightComponent